<template>
  <Adminlte>
    Welcome Park!
  </Adminlte>
</template>

<script>
import Adminlte from '@/components/template/Adminlte'
export default {
  name: 'ParkHome',
  components: { Adminlte }
}
</script>



// WEBPACK FOOTER //
// ParkHome.vue?4c8ea324